import s from './index.module.css'
import { useContext, useEffect, useState } from 'react'
import { UserContext } from 'components/UserProvider'
import { useYdCourseApp } from 'hooks/useYdCourseApp'

export function APPLoginMask(){
  const { user } = useContext(UserContext)
  const { isYdCourseAppWebView } = useYdCourseApp(user)
  const [ isShowMask, setIsShowMask ] = useState((isYdCourseAppWebView && user) || !isYdCourseAppWebView);

  useEffect(() => {
    setIsShowMask((isYdCourseAppWebView && user) || !isYdCourseAppWebView);
  }, [user, isYdCourseAppWebView]);

  if(isShowMask) return null;

  const handleLogin = () => {
    window.ydk.login({
      defer: 3000
    });
  };
  return (<div className={s.loginMask} onClick={handleLogin} />)
}